module.exports = __webpack_public_path__ + "static/media/master-card.d7f686ca.svg";